import {MouseEvent} from 'react';
import {commonUtils} from '@ibibo/hotel-utils';
import {apiConfig} from '@ibibo/hotels-config';
import Megatron from '@ibibo/megatron';

const d = {
  notice: [
    'The beach side shack / restaurant is closed from the period June to Sept due to monsoons.',
  ],
  pah_flag: false,
  cancel_policy_rule: [
    {
      policy_time: '14:00:00',
      start_day: -1,
      data_description:
        'Non-Refundable cancellation charges will be levied if cancelled before checkin',
      description: 'Booking is Non-Refundable.',
      charges: 100,
      charges_type: 'percent',
      end_day: 365,
    },
  ],
  cancelPolicy: [
    'Booking is Non-Refundable.',
    'Travel Cash used in the booking will be Non-Refundable.',
    'Any Add-on charges are Non-Refundable.',
    'You can not change the Check-in or Check-out date.',
  ],
  only_pah_flag: false,
  n: [
    'Travel Cash used in the booking will be Non-Refundable.',
    'Any Add-on charges are Non-Refundable.',
    'You can not change the Check-in or Check-out date.',
  ],
  crystal: true,
  fcdt: '',
  additional_hotel_policy: {
    'Hotel Policy': [],
  },
  cp: ['Booking is Non-Refundable.'],
  hotelPolicy: [],
};

type HotelCancellationPolicyDataType = {
  cancelPolicy: string[];
  cancellation_text: string[];
  // notice: string[];
  // pah_flat: boolean;
  // cancel_policy_rule: Array<{
  //   policy_time: string;
  //   start_day: string;
  //   data_description: string;
  //   description: string;
  //   charges: number;
  //   charges_type: string;
  //   end_day: number;
  // }>;
  // only_pah_flag: boolean;
  // n: string[];
  // crystal: boolean;
  // fcdt: string;
  // additional_hotel_policy: {
  //   "Hotel Policy": Array<any>
  // };
  // cp: string[];
  // hotelPolicy: string[];
};

type CancellationPolicyPropsTypes = {
  forwardParams: {
    prgen: string;
    vhid: string;
    ps: string; // format – "6000|4494|539"
    ts: string; // "2020-01-07T12:10:38"
    hctx: string;
    hctxty: string;
    srctx: string;
  };
  roomPriceCode: string;
  offercode: string;
  vendor: string;
  paymode: number;
  roomTypeCode: string;
  checkinYYYYMMDD: string;
  checkoutYYYYMMDD: string;
  cityCode: string;
  hotelCode: string;
  paxString: string;
  gseg: string;
  gsv: string;
  cot: string;
};

type FetchCancellationPolicyDataReturnType = [HotelCancellationPolicyDataType | null, Error | null];

async function hotelsPolicyApi(cancellationPolicyProps: CancellationPolicyPropsTypes) {
  // const allCancellationPolicyPropsArePresent = commonUtils.allFirstLevelObjectKeysAreNonNullable(
  //   cancellationPolicyProps,
  // );

  // if (!allCancellationPolicyPropsArePresent) {
  //   return [cancellationPolicyDefault, null] as FetchCancellationPolicyDataReturnType;
  // }

  const {
    hotelCode,
    roomTypeCode,
    roomPriceCode,
    offercode,
    forwardParams,
    vendor,
    cityCode,
    checkinYYYYMMDD,
    checkoutYYYYMMDD,
    paxString,
    paymode,
    gseg,
    gsv,
    cot
  } = cancellationPolicyProps;

  const cancellationPolicyQueryParams = {
    hotelCode: `hc=${hotelCode}`,
    roomTypeCode: `rtc=${roomTypeCode}`,
    roomPriceCode: `rpc=${encodeURIComponent(roomPriceCode)}`,
    offerCode: `offercode=${offercode}`,
    fwdParams: `fwdParams=${JSON.stringify(forwardParams)}`,
    vendor: `v=${vendor}`,
    sth: `strQry=hotels-${cityCode}-${checkinYYYYMMDD}-${checkoutYYYYMMDD}-${paxString}`,
    payMode: `pay_mode=${paymode}`,
    gseg: `segmentid=${gseg}`,
    gsv: `subvendor=${gsv}`,
    cot: `contracttype=${cot}`
  };

  const queryStringForCancellationUrl = Object.keys(cancellationPolicyQueryParams)
    .filter(sensibleQueryParamName => cancellationPolicyQueryParams[sensibleQueryParamName].length)
    .reduce((accumulatedQueryString, sensibleQueryParamName, index) => {
      const toAdd = cancellationPolicyQueryParams[sensibleQueryParamName];
      const prefix = index === 0 ? '?' : '&';

      return `${accumulatedQueryString}${prefix}${toAdd}`;
    }, '');

  const cancellationPolicyUrl = `${apiConfig.__MYPARTNER__}/${apiConfig.detailsAPIEndPoints.cancellationPolicy}/${queryStringForCancellationUrl}`;

  let hotelCancellationPolicyData: HotelCancellationPolicyDataType | null = null;
  let error = null;

  try {
    const response = await Megatron({
      name: 'cancellationPolicy',
      type: 'GET',
      credentials: 'include',
      url: cancellationPolicyUrl,
    });
    hotelCancellationPolicyData = response;
  } catch (e) {
    error = e;

    hotelCancellationPolicyData = d;
  }

  const ret: FetchCancellationPolicyDataReturnType = [hotelCancellationPolicyData, error];

  return ret;
}

export default hotelsPolicyApi;
